"use client";
import ActiveUser from "./dashboard/activeUser";
import AllGame from "./dashboard/allGame";
import Capacity from "./dashboard/capacity";
import PoppularGame from "./dashboard/poppularGame";
import RecommendGame from "./dashboard/recommendGame";
import UserEngagementRanking from "./dashboard/userEngagementRanking";

export default function Dashboard() {
    return (
        <section className="min-h-full">
            <div className="w-full max-w-[1200px] space-y-6">

                <div className="flex flex-col gap-6 md:flex-row">
                    <div className="h-32 w-full rounded-xl border border-gray-200 bg-white shadow-md xl:w-[400px]" >
                        <ActiveUser />
                    </div>
                </div>

                <div className="flex flex-col gap-6 xl:flex-row">
                    <div className="h-[520px] w-full rounded-xl border border-gray-200 bg-white shadow-md xl:w-[690px]">
                        <UserEngagementRanking />
                    </div>
                    <div className="h-[520px] w-full rounded-xl border border-gray-200 bg-white shadow-md xl:w-[690px]">
                        <RecommendGame />
                    </div>
                </div>

                <div className="flex flex-col gap-6 xl:flex-row">
                    <div className="h-[780px] w-full overflow-hidden rounded-xl border border-gray-200 bg-white shadow-md xl:w-[690px]">
                        <Capacity />
                    </div>
                    <div className="h-[780px] w-full rounded-xl border border-gray-200 bg-white shadow-md xl:w-[690px]">
                        <AllGame />
                    </div>
                </div>

                <div className="w-full rounded-xl border border-gray-200 bg-white shadow-md">
                    <PoppularGame />
                </div>

            </div>
        </section>
    );
}